export default __webpack_public_path__ + "d843e7b6c37bf1735bed83cc96407efa.webp";